import type { CSSProperties } from 'react';

export interface CellComponents {
  [key: string]: (props: any) => JSX.Element;
}

export interface TableComponents {
  Table: (props: any) => JSX.Element;
  TableHead: (props: any) => JSX.Element;
  TableBody: (props: any) => JSX.Element;
  TableFooter: (props: any) => JSX.Element;
  TableRow: (props: any) => JSX.Element;
  TableHeadCell: (props: any) => JSX.Element;
  TableCells: CellComponents;
}

export interface Column {
  style?: CSSProperties;
  label: string;
  propertyIds: string | string[];
  cellType: CellTypes;
  formatter?: (value: any) => any;
  headerComponent?: (value?: any) => any;
}

export interface TableDefinition {
  columns: Column[];
  config?: TableConfiguration;
}

export interface TableConfiguration {
  hideColumnsHeaders?: boolean;
  usePagination?: boolean;
  useSelectableRows?: boolean;
  rowsPerPage?: number;
  stickyHeader?: boolean;
  rowHeight?: string;
}

export interface Row {
  cells: Cell[];
  rowData?: any;
}

export interface Cell {
  value: any;
  column: Column;
}

export interface DataTable {
  rows: Row[];
}

export enum CellTypes {
  String,
  Number,
  Currency,
  Email,
  Select,
  Input,
  Checkbox,
  Image,
  TimeRange,
  Customer,
  Presence,
  Component,
}
